module.exports = __webpack_public_path__ + "images/usermodule/01.gif";


//////////////////
// WEBPACK FOOTER
// ./images/usermodule/01.gif
// module id = 1568
// module chunks = 4